export default __webpack_public_path__ + "static/media/section1-bg.fc305798.png";